var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9999 23.1342C13.6141 23.1342 10.8657 20.3858 10.8657 17C10.8657 13.6142 13.6141 10.8658 16.9999 10.8658C20.3857 10.8658 23.1341 13.6142 23.1341 17C23.1341 20.3858 20.3857 23.1342 16.9999 23.1342ZM16.9999 12.9908C14.7899 12.9908 12.9907 14.79 12.9907 17C12.9907 19.21 14.7899 21.0092 16.9999 21.0092C19.2099 21.0092 21.0091 19.21 21.0091 17C21.0091 14.79 19.2099 12.9908 16.9999 12.9908Z",
    fill: "#292D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9998 29.7783C11.6731 29.7783 6.64395 26.6617 3.18729 21.25C1.68562 18.9125 1.68562 15.1017 3.18729 12.75C6.65812 7.33835 11.6873 4.22168 16.9998 4.22168C22.3123 4.22168 27.3415 7.33835 30.7981 12.75C32.2998 15.0875 32.2998 18.8983 30.7981 21.25C27.3415 26.6617 22.3123 29.7783 16.9998 29.7783ZM16.9998 6.34668C12.424 6.34668 8.04645 9.09501 4.98645 13.8975C3.92395 15.555 3.92395 18.445 4.98645 20.1025C8.04645 24.905 12.424 27.6533 16.9998 27.6533C21.5756 27.6533 25.9531 24.905 29.0131 20.1025C30.0756 18.445 30.0756 15.555 29.0131 13.8975C25.9531 9.09501 21.5756 6.34668 16.9998 6.34668Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.84882123e66a40ca25f3dfef13151c45.svg";
export { ForwardRef as ReactComponent };